export default __webpack_public_path__ + "static/media/DeleteOutline.1b8f9f9b.svg";